import Svg from 'components/utilities/svg'

const CursorIcon = ({ ...props }) => (
  <Svg viewBox="0 -960 960 960" {...props}>
    <title>Cursor Icon</title>
    <path d="M551-80 406-392 240-160v-720l560 440H516l144 309-109 51Z" />
  </Svg>
)

CursorIcon.displayName = 'Cursor'

export default CursorIcon
